module.exports = __webpack_public_path__ + "assets/img/baoming.f0f4a7b0.png";